import type { ReactNode } from 'react';

export const symbol_drive_folder_upload: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h256q12.44 0 23.72 5t19.37 13.09L481-740h339q23 0 41.5 18.5T880-680v460q0 23-18.5 41.5T820-160H140Zm0-60h680v-460H456l-60-60H140v520Zm0 0v-520 520Zm361.5-68.63q8.5-8.62 8.5-21.37v-197l53 53q9 9 21 9t21-9q9-9 9-21t-9-21L501-600q-9-9-21-9t-21 9L355-496q-9 9-9 21t9 21q9 9 21 9t21-9l53-53v197q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63Z"
		/>
	</svg>
);
